import moment from 'moment-timezone';
import { history } from '../store';

export const handleDateURLParams = (fromDate, toDate) => {
  const { state, search } = history.location;
  const searchParams = new URLSearchParams(search);

  searchParams.set('fromDate', moment(fromDate).format());
  searchParams.set('toDate', moment(toDate).format());

  history.replace({
    state,
    search: searchParams.toString(),
  });
};

export const initDatesFromURL = () => {
  let initialFromDate = null,
    initialToDate = null;
  const url = new URL(window.location.href);
  const fromDateParam = url.searchParams.get('fromDate');
  const toDateParam = url.searchParams.get('toDate');
  if (fromDateParam && moment(decodeURIComponent(fromDateParam)).isValid()) {
    initialFromDate = moment(decodeURIComponent(fromDateParam)).startOf('day');
  }
  if (toDateParam && moment(decodeURIComponent(toDateParam)).isValid()) {
    initialToDate = moment(decodeURIComponent(toDateParam)).endOf('day');
  }
  return {
    fromDate: initialFromDate,
    toDate: initialToDate,
  };
};

/**
 * Add new query params to the current query params
 *
 * @param {Record<string, string>} currentQueryParams The current query params object
 * @param {Record<string, string>} newQueryParams The new query params to add
 *
 * @returns {string} The new query params, without the `?`
 */
export function addURLParams(currentQueryParams, newQueryParams) {
  // decode the current query params
  const decodedCurrentParams = {};
  Object.entries(currentQueryParams).forEach(([k, v]) => (decodedCurrentParams[k] = decodeURIComponent(v)));

  const currentParams = new URLSearchParams(decodedCurrentParams);
  for (const key in newQueryParams) {
    const value = newQueryParams[key];
    currentParams.set(key, value);
  }
  return currentParams.toString();
}
